import { createContext, useContext, useState, ReactNode } from 'react';

interface AIAssistantContextType {
  showAIDialog: boolean;
  openAIDialog: (onApplyFilters?: (answers: Record<string, string>) => void) => void;
  closeAIDialog: () => void;
  onApplyFiltersCallback?: (answers: Record<string, string>) => void;
}

const AIAssistantContext = createContext<AIAssistantContextType | undefined>(undefined);

export function AIAssistantProvider({ children }: { children: ReactNode }) {
  const [showAIDialog, setShowAIDialog] = useState(false);
  const [onApplyFiltersCallback, setOnApplyFiltersCallback] = useState<((answers: Record<string, string>) => void) | undefined>(undefined);

  const openAIDialog = (onApplyFilters?: (answers: Record<string, string>) => void) => {
    setOnApplyFiltersCallback(() => onApplyFilters);
    setShowAIDialog(true);
  };
  
  const closeAIDialog = () => setShowAIDialog(false);

  return (
    <AIAssistantContext.Provider value={{ showAIDialog, openAIDialog, closeAIDialog, onApplyFiltersCallback }}>
      {children}
    </AIAssistantContext.Provider>
  );
}

export function useAIAssistant() {
  const context = useContext(AIAssistantContext);
  if (context === undefined) {
    throw new Error('useAIAssistant must be used within an AIAssistantProvider');
  }
  return context;
}
